import { render, staticRenderFns } from "./cabinet-fl44-notice-card-edit-button.vue?vue&type=template&id=22d40c0a&"
import script from "./cabinet-fl44-notice-card-edit-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-notice-card-edit-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d40c0a')) {
      api.createRecord('22d40c0a', component.options)
    } else {
      api.reload('22d40c0a', component.options)
    }
    module.hot.accept("./cabinet-fl44-notice-card-edit-button.vue?vue&type=template&id=22d40c0a&", function () {
      api.rerender('22d40c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-edit-button.vue"
export default component.exports